import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MalayalamKeyboard from "../components/MalayalamKeyboard";
import MalayalamGrid from "../components/MalayalamGrid";
import axios from "axios";
import { API_URL } from "../components/Constant";
import WordSuggestion from "../components/WordSuggestions";
import { Tab, Tabs, Typography } from "@mui/material";
import EnterAnswerAudio from "../components/EnterAnswerAudio";

function NewGame1() {
  const [questions, setQuestions] = useState([]);
  const [highlightedBox, setHighlightedBox] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(null); // Timer state
  const [gameStarted, setGameStarted] = useState(false); // Game visibility
  const [publishingTime, setPublishingTime] = useState(null);

  const initialGridData = [
    // Row 0
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "1", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "2", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
    ],
    // Row 1
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "3", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 2
    [
      { value: "", answer: "", visible: false },
      { value: "4", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "5", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 3
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 4
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 5
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
    ],
    // Row 6
    [
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
      { value: "6", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
    ],
    // Row 7
    [
      { value: "7", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: true },
      { value: "", answer: "", visible: false },
      { value: "", answer: "", visible: false },
    ],
  ];

  const [allGridData, setAllGridData] = useState(initialGridData);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post(`${API_URL}/questions_newgame`, {
          game_id: "game1",
        });
        // console.log(response.data);
        setQuestions(response.data);
        const dynamicGrid = createDynamicGrid(response.data);
        // console.log("dynamicGrid",dynamicGrid)
        // setAllGridData(dynamicGrid)

        // Highlight the box corresponding to the first question on page load
        if (response.data.length > 0) {
          setHighlightedBox(response.data[0]); // Set the first question as highlighted
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQuestions();
  }, []);

  useEffect(() => {
    const fetchPublishingTime = async () => {
      try {
        const response = await axios.post(`${API_URL}/publishing_time`, {
          game_id: "game1",
        });

        // console.log(response.data[0].publishing_time);

        const publishTime = new Date(response.data[0].publishing_time); // Convert to Date object
        setPublishingTime(publishTime);

        const now = new Date();
        const timeDifference = publishTime - now;

        if (timeDifference > 0) {
          setTimeLeft(timeDifference);
          setGameStarted(false);
        } else {
          setGameStarted(true);
        }
      } catch (error) {
        console.error("Error fetching publishing time:", error);
      }
    };

    // Fetch publishing time initially
    fetchPublishingTime();

    // Set up a timer to fetch every minute
    const interval = setInterval(() => {
      fetchPublishingTime();
    }, 1000); // 60000ms = 1 minute

    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  useEffect(() => {
    if (timeLeft === null) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 1000) {
          clearInterval(timer);
          setGameStarted(true); // Game starts when timer ends
          return 0;
        }
        return prevTimeLeft - 1000;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTimeLeft = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      days: days.toString().padStart(2, "0"),
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  };

  function createDynamicGrid(dbResponses) {
    // Step 1: Determine the grid size dynamically
    let rows = 0;
    let cols = 0;

    dbResponses.forEach((data) => {
      const { row_index, col_index, length, direction } = data;
      if (direction === "down") {
        rows = Math.max(rows, row_index + length);
        cols = Math.max(cols, col_index + 1);
      } else if (direction === "across") {
        rows = Math.max(rows, row_index + 1);
        cols = Math.max(cols, col_index + length);
      }
    });

    // console.log("Rows: ", rows, "Cols: ", cols);

    // Step 2: Initialize the empty grid with correct dimensions
    const initialGridData = Array.from({ length: rows }, () =>
      Array.from({ length: cols }, () => ({
        value: "",
        visible: false,
      })),
    );

    dbResponses.forEach((data) => {
      const { row_index, col_index, direction, length, question_number } = data;

      if (direction === "down") {
        // Mark all cells in the vertical range as visible, only the first has the question number
        for (let i = 0; i < length; i++) {
          initialGridData[row_index + i][col_index] = {
            value: i === 0 ? question_number.toString() : "", // Only first cell gets the question number
            visible: true,
          };
        }
      } else if (direction === "across") {
        // Mark all cells in the horizontal range as visible, only the first has the question number
        for (let i = 0; i < length; i++) {
          initialGridData[row_index][col_index + i] = {
            value: i === 0 ? question_number.toString() : "", // Only first cell gets the question number
            visible: true,
          };
        }
      }
    });

    return initialGridData;
  }

  const handleCellClick = (question) => {
    setHighlightedBox(question);
    setCurrentQuestionIndex(question.question_number - 1);
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      setCurrentQuestionIndex(nextIndex);
      setHighlightedBox(questions[nextIndex]); // Highlight the next question
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      const prevIndex = currentQuestionIndex - 1;
      setCurrentQuestionIndex(prevIndex);
      setHighlightedBox(questions[prevIndex]); // Highlight the previous question
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue); // Update tab index
  };

  const handleQuestionClick = (question, index) => {
    handleCellClick({
      question_number: question.question_number,
      direction: question.direction,
      question_text: question.question_text,
      answer: question.answer,
      length: question.length,
    });
    setTabIndex(0); // Switch to the "Active Question" tab
    setCurrentQuestionIndex(question.question_number - 1); // Set the index of the selected question
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f1f3fc",
        minHeight: "100vh",
      }}
    >
      {gameStarted ? (
        questions.length > 0 && (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              gap: "12px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: "96%",
            }}
          >
            <h2>പദപ്രശ്നം</h2>
            {questions.length > 0 && (
              <MalayalamGrid
                highlightedBox={highlightedBox}
                onCellClick={handleCellClick}
                questions={questions}
                userAnswer={userAnswer}
                setHighlightedBox={setHighlightedBox}
                setUserAnswer={setUserAnswer}
                allGridData={allGridData}
                setAllGridData={setAllGridData}
              />
            )}

            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              centered
              sx={{
                ".MuiTabs-indicator": {
                  display: "none", // Hide the default indicator
                },
                display: "flex",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <Tab
                label="Active Question"
                sx={{
                  fontSize: "14px",
                  color: "#5BC8AC",
                  textDecoration: "none",
                  textUnderlineOffset: "5px",
                  "&:hover": {
                    textDecoration: "underline", // Apply underline on hover
                    textUnderlineOffset: "5px",
                    textDecorationThickness: "1.5px",
                  },
                  "&.Mui-selected": {
                    color: "#5BC8AC", // Keep the selected tab styled
                    textDecoration: "underline", // Underline for the active tab
                    textUnderlineOffset: "5px",
                    textDecorationThickness: "1.5px", // Make the underline bold for the active tab
                  },
                }}
              />
              <Tab
                label="All Questions"
                sx={{
                  fontSize: "14px",
                  color: "#F18D9E",
                  textDecoration: "none",
                  textUnderlineOffset: "5px",
                  "&:hover": {
                    textDecoration: "underline", // Apply underline on hover
                    textUnderlineOffset: "5px",
                    textDecorationThickness: "1.5px",
                  },
                  "&.Mui-selected": {
                    color: "#F18D9E", // Keep the selected tab styled
                    fontWeight: "bold",
                    textDecoration: "underline", // Underline for the active tab
                    textUnderlineOffset: "5px",
                    textDecorationThickness: "1.5px", // Make the underline bold for the active tab
                  },
                }}
              />
            </Tabs>

            {tabIndex === 0 && (
              <div>
                {highlightedBox ? (
                  <Box
                    sx={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h2 style={{ lineHeight: "0px" }}>
                      {highlightedBox.direction === "down"
                        ? "താഴോട്ട്"
                        : "വലത്തോട്ട്"}
                    </h2>
                    <p>
                      {highlightedBox.question_number}.{" "}
                      {highlightedBox.question_text}
                    </p>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        justifyContent: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Button
                        sx={{
                          background: "none",
                          color: "#5BC8AC",
                          fontSize: "14px",
                          textDecoration: "none",
                          textUnderlineOffset: "5px",
                          "&:hover": {
                            background: "none",
                            color: "#5BC8AC",
                            fontSize: "14px",
                            textDecoration: "underline", // Apply underline on hover
                            textUnderlineOffset: "5px",
                            textDecorationThickness: "1.5px",
                          },
                        }}
                        variant="text"
                        onClick={handlePrevious}
                        disabled={currentQuestionIndex === 0} // Disable if it's the first question
                      >
                        Previous
                      </Button>

                      <Button
                        sx={{
                          background: "none",
                          color: "#F18D9E",
                          fontSize: "14px",
                          textDecoration: "none",
                          textUnderlineOffset: "5px",
                          "&:hover": {
                            background: "none",
                            color: "#F18D9E",
                            fontSize: "14px",
                            textDecoration: "underline", // Apply underline on hover
                            textUnderlineOffset: "5px",
                            textDecorationThickness: "1.5px",
                          },
                        }}
                        variant="text"
                        color="primary"
                        onClick={handleNext}
                        disabled={currentQuestionIndex === questions.length - 1} // Disable if it's the last question
                      >
                        Next
                      </Button>
                    </Box>

                    <EnterAnswerAudio
                      highlightedBox={highlightedBox}
                      allQuestions={questions}
                      setHighlightedBox={setHighlightedBox}
                      setUserAnswer={setUserAnswer}
                      allGridData={allGridData}
                      setAllGridData={setAllGridData}
                    />
                  </Box>
                ) : (
                  <p>ക്ഷമയോടെ കാത്തിരിക്കുക...</p>
                )}
              </div>
            )}

            {tabIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginBottom: { md: "64px", xs: "30px" },
                }}
              >
                <h3>Question List</h3>
                {questions.map((q, index) => (
                  <div
                    key={index}
                    onClick={() => handleQuestionClick(q, index)} // Make each question clickable
                    style={{
                      cursor: "pointer",
                      marginBottom: "8px",
                      transition: "color 0.3s ease", // Smooth transition for the color change
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#32618D")} // Change color on hover
                    onMouseLeave={(e) => (e.target.style.color = "initial")} // Reset color when hover ends
                  >
                    <Typography sx={{ fontSize: "14px", fontFamily: "Roboto" }}>
                      {q.question_number}. {q.question_text}
                    </Typography>
                  </div>
                ))}
              </Box>
            )}
          </Box>
        )
      ) : (
        <Box sx={{ textAlign: "center", width: "100%", maxWidth: "96%" }}>
          {timeLeft && (
            <>
              <Typography
                variant="h4"
                sx={{
                  color: "#32618D",
                  marginBottom: { md: "36px", xs: "24px" },
                }}
              >
                Get Ready...
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  color: "#5BC8AC",
                  textAlign: "center",
                  display: "flex",
                  gap: { md: "20px", xs: "8px" },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {timeLeft && (
                  <>
                    <Box
                      sx={{
                        textAlign: "center",
                        width: { md: "140px", xs: "80px" },
                        height: { md: "140px", xs: "80px" },
                        borderRadius: "16px",
                        background: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        gap: { md: "16px", xs: "4px" },
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#5BC8AC",
                          fontFamily: "Roboto",
                          fontSize: { md: "64px", xs: "30px" },
                          lineHeight: { md: "48px", xs: "30px" },
                        }}
                      >
                        {formatTimeLeft(timeLeft).days}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#F18D9E",
                          fontFamily: "Roboto",
                          fontSize: { md: "24px", xs: "16px" },
                          lineHeight: { md: "24px", xs: "16px" },
                        }}
                      >
                        Days
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: "center",
                        width: { md: "140px", xs: "80px" },
                        height: { md: "140px", xs: "80px" },
                        borderRadius: "16px",
                        background: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        gap: { md: "16px", xs: "4px" },
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#5BC8AC",
                          fontFamily: "Roboto",
                          fontSize: { md: "64px", xs: "30px" },
                          lineHeight: { md: "48px", xs: "30px" },
                        }}
                      >
                        {formatTimeLeft(timeLeft).hours}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#F18D9E",
                          fontFamily: "Roboto",
                          fontSize: { md: "24px", xs: "16px" },
                          lineHeight: { md: "24px", xs: "16px" },
                        }}
                      >
                        Hours
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: "center",
                        width: { md: "140px", xs: "80px" },
                        height: { md: "140px", xs: "80px" },
                        borderRadius: "16px",
                        background: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        gap: { md: "16px", xs: "4px" },
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#5BC8AC",
                          fontFamily: "Roboto",
                          fontSize: { md: "64px", xs: "30px" },
                          lineHeight: { md: "48px", xs: "30px" },
                        }}
                      >
                        {formatTimeLeft(timeLeft).minutes}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#F18D9E",
                          fontFamily: "Roboto",
                          fontSize: { md: "24px", xs: "16px" },
                          lineHeight: { md: "24px", xs: "16px" },
                        }}
                      >
                        Minutes
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: "center",
                        width: { md: "140px", xs: "80px" },
                        height: { md: "140px", xs: "80px" },
                        borderRadius: "16px",
                        background: "white",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        gap: { md: "16px", xs: "4px" },
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#5BC8AC",
                          fontFamily: "Roboto",
                          fontSize: { md: "64px", xs: "30px" },
                          lineHeight: { md: "48px", xs: "30px" },
                        }}
                      >
                        {formatTimeLeft(timeLeft).seconds}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#F18D9E",
                          fontFamily: "Roboto",
                          fontSize: { md: "24px", xs: "16px" },
                          lineHeight: { md: "24px", xs: "16px" },
                        }}
                      >
                        Seconds
                      </Typography>
                    </Box>
                  </>
                )}
              </Typography>
            </>
          )}
        </Box>
      )}
    </Box>
  );
}

export default NewGame1;
